import externalServices from './externalServices.json';

export const EXTERNAL_SERVICES = {

  OTP_HOST: externalServices.otp.baseUrl,
  OTP_GROUP: externalServices.otp.group,
  OTP_SEND_URL: externalServices.otp.sendOtpPath,

  EMAIL_GROUP: externalServices.email.group,
  EMAIL_SEND_URL: externalServices.email.sendHtmlEmailWithCustomSource
};

export default EXTERNAL_SERVICES;
